"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.identity = identity;
function identity(x) {
    return x;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/identity.js
// module id = 426
// module chunks = 171